export const buildUrl = (url: string, params: any) => {
  const queryParams = Object.assign({}, params);
  for (const key of Object.keys(queryParams)) {
    if (queryParams[key] === undefined) {
      delete queryParams[key];
    }
  }

  const query = new URLSearchParams(queryParams).toString();
  return query ? `${url}?${query}` : url;
};
